import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  name: string;
};

export const LawFirmTop: FC<Props> = ({ name }) => {
  return (
    <>
      <div
        className="entity__header__picture"
        style={{ backgroundImage: 'url(/img/icons/entities/law-firm.svg)' }}
      />
      <h1 className="entity__header__title">{name}</h1>
      <div>
        <FormattedMessage id="law-firm/page/header/Top.tsx/1" />
      </div>
    </>
  );
};
